





















































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { Filter } from '../../filter'
import FilterWrapper from '@/modules/common/filter/components/shared/layout/FilterWrapper.vue'
import { FilterService } from '@/modules/common/filter/services/filter.service'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: {
    BaseButton,
    FilterWrapper
  }
})
export default class FilterButton extends Vue {
  constructor(
    private readonly filterService: FilterService
  ) {
    super()
  }

  @Prop({
    required: true
  }) filters!: Filter[]

  dialogOpen = false

  clear() {
    this.filterService.clear()
    this.filterService.submit()
    this.dialogOpen = false
  }

  mounted() {
    this.filterService.mount(this.filters)
  }
}
